import { render, staticRenderFns } from "./BasalStudy.vue?vue&type=template&id=3d99ed6e&scoped=true&"
import script from "./BasalStudy.vue?vue&type=script&lang=js&"
export * from "./BasalStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d99ed6e",
  null
  
)

export default component.exports